document.addEventListener("DOMContentLoaded", (e) => {
    const timelineLink = document.querySelectorAll( '.ctl-story .story-link' );

    if ( timelineLink ) {
        timelineLink.forEach( ( link ) => {
            link.addEventListener( 'click', ( e ) => {
                e.preventDefault();
            } );
        } );
    }
} ); // End document ready
